import { useLink } from "../../other/navigationAndRouting/useLink";
import { communityRoute } from "../../other/navigationAndRouting/routes";

export function InternalMediaListLink(): React.ReactElement {
    const link = useLink({ route: communityRoute });
    return (
        <a
            href={link.href}
            onClick={link.onClick}
            target={link.target}
            data-testid="internalMediaAllPosts"
            className="rounded border border-gray-300 bg-white px-3 py-1 text-sm text-gray-600 transition-colors duration-150 hover:bg-gray-50 hover:text-gray-900"
        >
            ← Back to all posts
        </a>
    );
}
